import { FormComponentProps } from "components/Form/components/FormComponentProps";
import { Input } from "components/Form/components/Input/Input";
import { Url } from "components/Form/components/Url/Url";
import { getRelativeUrl } from "utils/service";
import { testHTTP } from "utils/utils";

export const UrlFormComponent = ({ input, meta, fieldProps, fieldAttr }: FormComponentProps) => {
    const isReadOnly = !!(fieldAttr.disabled || fieldProps.relativePath || fieldProps.asLink);

    const relativeUrl =
        fieldProps.relativePath && input.value?.id
            ? getRelativeUrl(fieldProps.relativePath, input.value.id)
            : null;
    const url = relativeUrl ?? input.value;
    const text = relativeUrl ? input.value.name : input.value;
    const isOpenLinkButtonShown = !!(testHTTP(input.value) || relativeUrl);
    const id = input.name;

    return (
        <Input fieldProps={fieldProps} fieldAttr={fieldAttr} input={input} meta={meta}>
            <Url
                isReadOnly={isReadOnly}
                url={url}
                text={text}
                isOpenLinkButtonShown={isOpenLinkButtonShown}
                id={id}
                input={input}
                target={relativeUrl ? "" : "_blank"}
            />
        </Input>
    );
};
